import { createSelector } from 'reselect';

const getQuizzes = state => state.quizzes;
const getSlug = (state, props) => props.match.params.module;

const getQuizBySlug = createSelector([getQuizzes, getSlug], (quizzes, slug) => quizzes[slug]);

export default getQuizBySlug;
